import { useRef } from "react";
import { Clue, clueClass } from "./clue";
import dictionary from "./fives_dictionary.json";

interface KeyboardProps {
  layout: string;
  letterInfo: Map<string, Clue>;
  onKey: (key: string) => void;
  juiceGreen?: boolean;
  onJuiceDone?: () => void;
}

export function Keyboard(props: KeyboardProps) {
  const keyboard = props.layout
    .split("-")
    .map((row) =>
      row
        .split("")
        .map((key) => key.replace("B", "Backspace").replace("E", "Enter").replace("D","Delete").replace("L","ArrowLeft").replace("R","ArrowRight").replace("S","SpaceBar"))
    );

  // Count total green keys for stagger indexing
  let totalGreenKeys = 0;
  if (props.juiceGreen) {
    keyboard.forEach(row => row.forEach(label => {
      if (label.length === 1 && props.letterInfo.get(label) === Clue.Correct) {
        totalGreenKeys++;
      }
    }));
  }

  const juiceDoneFired = useRef(false);
  let greenIndex = 0;
  return (
    <div className="Game-keyboard" aria-hidden="true">
      {keyboard.map((row, i) => (
        <div key={i} className="Game-keyboard-row">
          {row.map((label, j) => {
            let className = "Game-keyboard-button";
            const clue = props.letterInfo.get(label);
            if (clue !== undefined) {
              className += " " + clueClass(clue);
            }
            if (label.length > 1) {
              className += " Game-keyboard-button-wide";
            }
            const isGreenKey = label.length === 1 && clue === Clue.Correct;
            const isLastGreen = isGreenKey && props.juiceGreen && greenIndex === totalGreenKeys - 1;
            if (props.juiceGreen && isGreenKey) {
              className += " keyboard-juice-green";
            }
            const style = (props.juiceGreen && isGreenKey)
              ? { "--juice-i": greenIndex++ } as React.CSSProperties
              : undefined;
            return (
              <button
                tabIndex={-1}
                key={j}
                className={className}
                style={style}
                onAnimationEnd={isLastGreen ? () => {
                  if (!juiceDoneFired.current) {
                    juiceDoneFired.current = true;
                    props.onJuiceDone?.();
                  }
                } : undefined}
                onClick={() => {
                  props.onKey(label);
                }}
              >
                {label.replace("Backspace", "⌫").replace("Delete","Del").replace("ArrowLeft","←").replace("ArrowRight","→").replace("SpaceBar","  ")}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
